import { Price } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { CustomProductActions } from '../actions';

export const initialState: Price[] = undefined;

export function reducer(
  state = initialState,
  action: StateUtils.LoaderAction | CustomProductActions.SetPrices | CustomProductActions.LoadPricesSuccess,
): Price[] {
  switch (action.type) {
    case CustomProductActions.LOAD_PRICES_SUCCESS:
    case CustomProductActions.SET_PRICES: {
      const { payload } = action;

      return payload;
    }

    default: {
      return state;
    }
  }
}
